import { render, staticRenderFns } from "./@PopupSectionTaskGalleryNew.vue?vue&type=template&id=0a7478dc&scoped=true&"
import script from "./@PopupSectionTaskGalleryNew.vue?vue&type=script&lang=js&"
export * from "./@PopupSectionTaskGalleryNew.vue?vue&type=script&lang=js&"
import style0 from "./@PopupSectionTaskGalleryNew.vue?vue&type=style&index=0&id=0a7478dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7478dc",
  null
  
)

export default component.exports